<template>
  <v-form>
    <v-container>
      <span v-if="editMotorTypeId == -1" class="headline">{{ $t('create_motor_type') }}</span>
      <span v-if="editMotorTypeId != -1" class="headline">{{ $t('edit_motor_type') }}</span>

      <v-row>
        <v-col cols="12" lg="2" md="3" sm="4">
          <v-text-field v-model="motorType.type" :label="$t('motor.type')"></v-text-field>
        </v-col>

        <!-- <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motorType.frequency" label="Frequency"></v-text-field>
        </v-col> -->

        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motorType.phase" :label="$t('motor.phase')"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field
            v-model="motorType.voltage"
            suffix="V"
            :label="$t('motor.voltage')"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motorType.fi_d_max" suffix="mm" 
          :label="$t('nominal_diameter')"></v-text-field>
        </v-col>

        
      </v-row>

      
          <v-row>
    <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field
            v-model="motorType.max_water_temp"
            suffix="C"
            :label="$t('motor.max_water_temp')"
          ></v-text-field>
        </v-col>  

            <v-col cols="12" md="3" lg="2" sm="4">
          <v-text-field v-model="motorType.degree_of_protection" suffix="" 
          :label="$t('motor.protection_degree')"></v-text-field>
        </v-col>  
         </v-row>
        
       
      <div class="my-2">
        <v-btn v-if="editMotorTypeId == -1" color="primary" @click="saveMotorType">{{ $t('save') }}</v-btn>
        <v-btn v-if="editMotorTypeId != -1" color="primary" @click="saveMotorType">{{ $t('update') }}</v-btn>
      </div>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "MotorTypesAdd",

  data: () => ({
    token: "",
    query: "",
    motorType: {
      idmotor_type: -1,
      type: "",
      frequency: "",
      phase: "",
      voltage : "",
      fi_d_max : "",
      degree_of_protection : "",
      max_water_temp : "",
    } 
  }),

  props: {
    editMotorTypeId: {
      type: String,
      default: "-1"
    }
  },

  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    if ( this.editMotorTypeId != -1){
        this.fetchMotorType(this.editMotorTypeId)
      }
  },
  methods: {
    fetchMotorType: function(editMotorTypeId) {
      this.$http.get(this.$API_URL + "motor_type?idmotor_type=" + editMotorTypeId).then(result => {
        this.motorType = result.data
      });
    },
    saveMotorType: function() {
      var targetUrl = this.editMotorTypeId == -1 ? "save_motor_type" : "update_motor_type";

      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + targetUrl,
        data: this.motorType
      })
        .then(function(response) {
          console.log(response.data)
          if (response.data == "1")
             window.history.go(-1)
        })
        .catch(function(error) {
          console.log(error);
        });
    },

     
  }
};
</script>
